module.exports = __webpack_public_path__ + "img/forward_proxy.acee903f.png";